import { getWeekDay } from '@/util/dates';
const clearDateInfo = ({ commit }) => {
    commit('CLEAR_DATE_INFO');
};
const setCurrentDay = ({ commit }, day) => {
    const week = getWeekDay(day);
    commit('SET_CURRENT_DAY', { day, week });
};
const setSelectedCalendarDay = ({ commit }, day) => {
    commit('SET_SELECTED_CALENDAR_DAY', day);
};
export default {
    clearDateInfo,
    setSelectedCalendarDay,
    setCurrentDay
};
